// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles-" + "0b99704e50d3db360bfa" + ".css";
};